import type { InvariantJiraRoute } from '@atlassian/jira-route-types/src/InvariantJiraRoute.tsx';

export const softwareDeploymentsClassicRoute: InvariantJiraRoute = {
	name: 'software-deployments-classic',
	path: '/jira/software/c/projects/:projectKey/deployments',
};
